var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 bg-white"},[_c('div',{staticClass:"min-vh-100 bg-white border border-1 d-flex justify-content-center align-items-center"},[_c('h4',{staticClass:"text-secondary size-18"},[_c('font-awesome-icon',{staticClass:"me-1",attrs:{"icon":['fas', 'sync-alt']}}),_vm._v(" Cargando ...")],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }